import browserHydrateFunction from './src/utils/browserHydrateFunction';
import { initializeParse, initializeLiveQuery } from "./src/utils/parse";

export const replaceHydrateFunction = browserHydrateFunction;

export const onClientEntry = async () => {
    await initializeParse();
    await initializeLiveQuery();
};
